module.exports = "/_next/static/resources/photo-2-93005f5c903ad15d6b6b17865c15f10c.webp";